// extracted by mini-css-extract-plugin
export var deleteModal = "_g1-0";